import type { TSectionElement } from '@shared/dream-components';

import type { NodeContent } from '~/interfaces/page';
import type { Publication } from '~/interfaces/publication';

import { findColorInTipTapNode } from '../findColorInTipTapNode';
import { findTipTapContentNode } from '../findTipTapContentNode';

export function getColors(lastSection: TSectionElement, webTheme: Publication['web_theme']) {
  let textColor: string | undefined;
  try {
    const headingNode = findTipTapContentNode(
      lastSection as NodeContent,
      'heading',
      (node: NodeContent) => !!node?.content && node.content.length > 0,
    );

    if (headingNode) {
      textColor = findColorInTipTapNode(headingNode);
    }

    if (!textColor) {
      const paragraphNode = findTipTapContentNode(
        lastSection as NodeContent,
        'paragraph',
        (node: NodeContent) => !!node?.content && node.content.length > 0,
      );

      if (paragraphNode) {
        textColor = findColorInTipTapNode(paragraphNode);
      }
    }

    if (!textColor) {
      // Assign text color based on section's background color
      if (lastSection.attrs.backgroundColor === webTheme.primary_color) {
        textColor = webTheme.text_on_primary_color;
      } else if (lastSection.attrs.backgroundColor === webTheme.background_color) {
        textColor = webTheme.text_on_background_color;
      }
    }
  } catch {
    // do nothing
  }

  return {
    textColor,
  };
}
